export const LogoIcon = () => (
  <img src="/logo.svg" alt="Developer Portal" style={{ height: 28, width: 'auto' }} />
);
